import { Component, ChangeDetectionStrategy } from '@angular/core'

import { MatIcon } from '@angular/material/icon'
import { MatDialogRef } from '@angular/material/dialog'

import { ButtonComponent } from '../../../../../components/button/button.component'

@Component({
  selector: 'app-salesforce-integration-validation-success',
  standalone: true,
  imports: [MatIcon, ButtonComponent],
  templateUrl: './salesforce-integration-validation-success.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./salesforce-integration-validation-success.component.scss'],
})
export class SalesforceIntegrationValidationSuccessComponent {
  constructor(
    private dialogRef: MatDialogRef<SalesforceIntegrationValidationSuccessComponent>,
  ) {}

  close(): void {
    this.dialogRef.close()
  }
}
